export const LISTENER_TYPES = {
  BLUR: "BLUR",
  FOCUS: "FOCUS",
  CLICK: "CLICK",
  TIMEOUT: "TIMEOUT",
  HEARTBEAT: "HEARTBEAT",
};

const mod = () => {
  let heartBeatInterval = null;
  const addClickListener = (window, clickFn) => {
    window.addEventListener("click", () => {
      clickFn();
    });
  };
  const addFocusListener = (window, focusFn) => {
    window.addEventListener("focus", () => {
      focusFn();
    });
  };
  const addBlurListener = (window, blurFn) => {
    window.addEventListener("blur", () => {
      blurFn();
    });
  };

  const addHeartBeatListener = (heartBeatFn) => {
    if (heartBeatInterval != null) {
      clearInterval(heartBeatInterval);
      heartBeatInterval = null;
    }
    heartBeatInterval = setInterval(() => {
      heartBeatFn();
    }, 10000);
  };

  const removeHeartBeatListener = () => {
    clearInterval(heartBeatInterval);
    heartBeatInterval = null;
  };

  const addModeListener = (window, modeListenerFn) => {
    window.addEventListener("popstate", () => {
      modeListenerFn();
    });
  };
  const addResizeListener = (window, resizeFn) => {
    window.addEventListener("resize", () => {
      resizeFn();
    });
  };

  return {
    addClickListener,
    addHeartBeatListener,
    addFocusListener,
    addBlurListener,
    removeHeartBeatListener,
    addModeListener,
    addResizeListener,
  };
};

const Listeners = mod();
export default Listeners;
